import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastCloseButtonFn = /* @__PURE__ */ createRecipe('toast-close-button', {}, [])

const toastCloseButtonVariantMap = {}

const toastCloseButtonVariantKeys = Object.keys(toastCloseButtonVariantMap)

export const toastCloseButton = /* @__PURE__ */ Object.assign(memo(toastCloseButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastCloseButton',
  __getCompoundVariantCss__: toastCloseButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastCloseButtonVariantKeys,
  variantMap: toastCloseButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastCloseButtonVariantKeys)
  },
  getVariantProps: toastCloseButtonFn.getVariantProps,
})